// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3VoE2","TitleContainer":"Header_TitleContainer__2lSwh","Mainlogo":"Header_Mainlogo__pa1Dd","Title":"Header_Title__1uqTd"};